import { render, staticRenderFns } from "./AddTemplateApproval.vue?vue&type=template&id=02ee1dd0&scoped=true&"
import script from "./AddTemplateApproval.vue?vue&type=script&lang=js&"
export * from "./AddTemplateApproval.vue?vue&type=script&lang=js&"
import style0 from "./AddTemplateApproval.vue?vue&type=style&index=0&id=02ee1dd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ee1dd0",
  null
  
)

component.options.__file = "AddTemplateApproval.vue"
export default component.exports